import { ExperimentId } from 'core/type/ExperimentId';
import { isB } from 'core/window/bootstrapConfig';
import { ExperimentsPipeline } from '@drone-js/core';

const mapDesignSystemExperiments = (experiments: Partial<Record<ExperimentId, boolean>>) => {
    const isBWrapper = (name: string) => isB(name as ExperimentId, experiments);
    return ExperimentsPipeline.mapDesignSystemExperiments(isBWrapper, {
        cssArchitecture: true,
        gridSizeFallback: true,
        alwaysMountTooltip: true,
    });
};

export { mapDesignSystemExperiments };
